import Footer from "@/components/Footer";

const TEAM = [
  {
    name: "Massimiliano Napolitano",
    role: "Fondatore & Direttore Artistico",
    photo:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    bio: "Trent'anni di palchi, dai teatri storici alle piazze estive. Ha creduto per primo che una band possa cambiare il modo in cui una città festeggia.",
  },
  {
    name: "Head of Booking",
    role: "Coordinamento Artisti",
    photo:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    bio: "Selezione, contratti e agenda di oltre 60 artisti tra roster stabile e ospiti speciali. La cassaforte del nostro roster.",
  },
  {
    name: "Head of Production",
    role: "Regia & Tecnica",
    photo:
      "https://images.unsplash.com/photo-1495653797063-114787b77b23?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    bio: "Rider, service, permessi, SIAE. Se il tuo evento deve girare come un orologio, è la persona da avere in cabina di regia.",
  },
];

const PILLARS = [
  { n: "01", t: "Curiamo", d: "Un roster selezionato di artisti verificati, non un elenco infinito." },
  { n: "02", t: "Produciamo", d: "Rider, service, permessi, SIAE, palco: dalla scintilla alle luci accese." },
  { n: "03", t: "Amplifichiamo", d: "Promozione radio, TV, stampa e web: che il tuo evento resti nella memoria collettiva." },
];

export default function About() {
  return (
    <div className="pt-28 pb-16">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="av-eyebrow">Chi siamo</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-tight">
          Siamo <span className="italic text-[#E5A93C]">NMA Agency</span>.
          <br className="hidden sm:block" />
          E costruiamo eventi che si ricordano.
        </h1>
        <p className="text-[#F7F4EE]/80 max-w-2xl mt-6 leading-relaxed text-base sm:text-lg">
          ArtVision è il palco digitale di <strong>Napolitano Max Agency</strong>. Da
          oltre 30 anni portiamo musica, teatro e spettacolo dai grandi teatri storici
          alle piazze di provincia, dai gala aziendali agli after party privati. Un
          unico interlocutore, decine di artisti, una sola parola d'ordine: coerenza
          artistica.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mt-16" data-testid="about-pillars">
          {PILLARS.map((p) => (
            <div key={p.n} className="av-card p-8" data-testid={`pillar-${p.n}`}>
              <div className="text-[#E5A93C] font-mono text-sm">{p.n}</div>
              <h3 className="font-serif-display text-2xl mt-3">{p.t}</h3>
              <p className="text-[#A39E93] mt-3 text-sm leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>

        <h2 className="font-serif-display text-3xl sm:text-5xl mt-24 leading-tight">
          Il <span className="italic text-[#E5A93C]">team</span>
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10" data-testid="about-team">
          {TEAM.map((m) => (
            <article key={m.name} className="av-card overflow-hidden" data-testid={`team-${m.name.split(" ")[0].toLowerCase()}`}>
              <div className="aspect-[4/5] overflow-hidden">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-2xl">{m.name}</h3>
                <p className="text-xs text-[#E5A93C] uppercase tracking-widest mt-1">{m.role}</p>
                <p className="text-sm text-[#F7F4EE]/70 mt-3 leading-relaxed">{m.bio}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="av-card p-8 mt-20 text-center">
          <span className="av-eyebrow">Contatti</span>
          <h3 className="font-serif-display text-3xl mt-3">Scriviamoci</h3>
          <p className="text-sm text-[#A39E93] mt-2">
            info@nma-agency.it · Via del Teatro 1, Napoli · IT
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
